import React from 'react'
import { data } from 'jquery'
import { runQuery } from '../../fetchUtils'
import { OnboardingTeacherContext } from '../../contexts/OnboardingTeacherContextProvider'
import { convertStudentStartTrack, convertTeacherStartTrack, status } from './onboardingUtils'
import _ from 'lodash'

// note: stepId is an int from 0-8
// 0 - Visited Storylines Page
// 1 - ASsigned A Quest To themselves
// 2 - Created a character in game
// 3 - Completed a Quest in game
// ----------
// 4 - created a class
// 5 - has at least one student in a class
// 6 - has a student that has created a character in game
// 7 - has created an assignment for a student
// 8 - has a student that has completed an assignment

export const useOnboardingUtils = () => {
    const { setTeacherStartTrack, setStudentStartTrack, setActiveKeyList, setCurrentPath } =
        React.useContext(OnboardingTeacherContext)

    //handles skipping action on onboarding homepage / onboarding banner
    const handleTaskSkip = React.useCallback(stepId => {
        const onboardingSkipQuery = `
            mutation SkipOnboardingStep($stepId: Int!){
                skipOnboardingStep(stepId:$stepId){
                    updatedContext{
                        hasVisitedStorylines
                        hasSelfAssigned
                        hasCreatedCharacter
                        hasCompletedQuest
                        hasCreatedClass
                        hasPopulatedClass
                        hasStudentCreatedCharacter
                        hasCreatedStudentAssignment
                        hasStudentCompletedQuest
                        allCompletedSteps
                        personalOnboardingStepsCompleted
                        classOnboardingStepsCompleted
                        allOnboardingStepsCompleted
                    }
                    errors
                }
            }
        `
        const vars = {
            stepId: stepId
        }

        const callbacks = {
            onComplete: json => {
                const errors = json.data.skipOnboardingStep.errors
                if (!_.isEmpty(errors)) {
                    errors.map(error => console.error(error))
                } else {
                    const teacherTrackUpdate = convertTeacherStartTrack(
                        json.data.skipOnboardingStep.updatedContext
                    )
                    const studentTrackUpdate = convertStudentStartTrack(
                        json.data.skipOnboardingStep.updatedContext
                    )
                    setTeacherStartTrack(prev => ({
                        ...prev,
                        ...teacherTrackUpdate
                    }))
                    setStudentStartTrack(prev => ({
                        ...prev,
                        ...studentTrackUpdate
                    }))
                    setActiveKeyList([
                        ..._.values(teacherTrackUpdate.steps).map(
                            value => value === _.indexOf(status, 'inProgress')
                        ),
                        ..._.values(studentTrackUpdate.steps).map(
                            value => value === _.indexOf(status, 'inProgress')
                        )
                    ])
                }
            },
            onFailure: error => {
                console.error(error)
            }
        }

        runQuery(onboardingSkipQuery, vars, callbacks)
    }, [])

    const handlePathChange = React.useCallback(pathName => {
        setCurrentPath(pathName)
    }, [])



    return {
        handleTaskSkip: stepId => handleTaskSkip(stepId),
        handlePathChange: pathName => handlePathChange(pathName)
    }
}
